export enum ContentTypeEnum {
    PDF = "application/pdf",
    JSON = "application/json",
    EXCEL = "application/vnd.ms-excel"
}
